import { WORKOUT_KEY } from '../../../../../modules/workout/model'
import { WORKOUT_SECTION_CLASS_NAME, WORKOUT_SECTION_KEY } from '../../../model'
import getWorkoutSectionsWorkoutUtil from '../../../../../modules/workout/model/utils/get-workout-sections'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import createReduxAction from '../../../../redux/actions/create'
import updateReduxAction from '../../../../redux/actions/update'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { saveWorkoutSectionAction } from '../save'
import updateCurrentWorkoutSectionAction from '../update-current'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import WORKOUT_SECTIONS_ANALYTICS_EVENT from '../../constants/analytics-event'
import getCurrentWorkoutSectionSelect from '../../selectors/get-current'
import WORKOUTS_ACTION from '../../../../workout/redux/constants/action'
import getCurrentOrStartedWorkoutSelect from '../../../../workout/redux/selectors/get-current-or-started'
import { logEventAnalyticsUtil } from '../../../../../utils/analytics/log-event'
import { flattenArrayUtil } from 'packages/src'

function createWorkoutSectionAction ({
  type = WORKOUT_SECTIONS_ACTION.CREATE,
  data = {},
  analyticEvent = WORKOUT_SECTIONS_ANALYTICS_EVENT.CREATED,
  changed = {}
} = {}) {
  return (dispatch, getState) => {
    const workout = getCurrentOrStartedWorkoutSelect(getState())
    if (!workout) {
      return
    }
    const currentWorkoutSection = getCurrentWorkoutSectionSelect(getState())
    const workoutSectionPointers = getWorkoutSectionsWorkoutUtil(workout)

    changed = {
      [WORKOUT_SECTION_KEY.WORKOUT_EXERCISES]: [],
      [WORKOUT_SECTION_KEY.NAME]: 'New Section',
      [WORKOUT_SECTION_KEY.NOTES]: '',
      [WORKOUT_SECTION_KEY.ORDER]: currentWorkoutSection
        ? getValueReduxUtil(currentWorkoutSection, WORKOUT_SECTION_KEY.ORDER) +
        1
        : workoutSectionPointers.length + 1,
      [WORKOUT_SECTION_KEY.WORKOUT_ID]: getIdReduxUtil(workout),
      [WORKOUT_SECTION_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(
        getState()),
      ...changed
    }

    const workoutSection = dispatch(createReduxAction({
      type,
      payload: {
        data: {
          className: WORKOUT_SECTION_CLASS_NAME,
          changed,
          data
        }
      }
    }))

    const newWorkoutSectionPointer = createPointerReduxUtil(workoutSection)
    const newId = getIdReduxUtil(newWorkoutSectionPointer)
    const currentWorkoutSectionId = getIdReduxUtil(currentWorkoutSection)
    const newWorkoutSectionPointers = flattenArrayUtil(workoutSectionPointers.map(
      workoutSectionPointer => {
        const res = [workoutSectionPointer]
        if (getIdReduxUtil(workoutSectionPointer) === currentWorkoutSectionId) {
          res.push(newWorkoutSectionPointer)
        }
        return res
      }))
    if (!newWorkoutSectionPointers.length) {
      newWorkoutSectionPointers.push(newWorkoutSectionPointer)
    }

    dispatch(updateReduxAction({
      type: WORKOUTS_ACTION.ADD_WORKOUT_SECTIONS,
      payload: {
        path: getPathReduxUtil(workout),
        key: WORKOUT_KEY.WORKOUT_SECTIONS,
        value: newWorkoutSectionPointers
      }
    }))

    dispatch(saveWorkoutSectionAction(newId))

    dispatch(updateCurrentWorkoutSectionAction(newId))

    logEventAnalyticsUtil(analyticEvent, workoutSection)
  }
}

export default createWorkoutSectionAction
